const benefit = (type, id, title, description) => ({
  type,
  id,
  title,
  description,
  key: `${type}:${id || ''}:${`${title || ''}|${description || ''}`.trim()}`,
});

export const productBenefits = (item) => {
  const promotions = (item.Promotions || []).map((promotion) => benefit(
    'promotion',
    promotion.Id,
    promotion.Title || promotion.Category || '優惠',
    promotion.Description
      || [promotion.Type, promotion.Method, promotion.Condition, promotion.Value].filter(Boolean).join(' / '),
  ));
  const addons = (item.AddonRules || []).map((rule) => benefit(
    'addon',
    rule.Id,
    rule.Name || '加購優惠',
    '',
  ));
  return [...promotions, ...addons];
};

export const groupCampOverview = (items) => {
  const groups = new Map();
  items.forEach((item) => {
    const id = item.ProgramId || item.ProgramName || 'empty';
    if (!groups.has(id)) {
      groups.set(id, {
        id,
        name: item.ProgramName || '未命名課程',
        GradeMin: item.GradeMin,
        GradeMax: item.GradeMax,
        products: [],
      });
    }
    groups.get(id).products.push({ ...item, benefits: productBenefits(item) });
  });

  return Array.from(groups.values()).map((program) => {
    const commonKeys = program.products.length
      ? program.products[0].benefits
        .map((item) => item.key)
        .filter((key) => program.products.every((product) => product.benefits.some((item) => item.key === key)))
      : [];
    const commonBenefits = program.products[0]
      ? program.products[0].benefits.filter((item) => commonKeys.includes(item.key))
      : [];
    return {
      ...program,
      commonBenefits,
      products: program.products.map((product) => ({
        ...product,
        uniqueBenefits: product.benefits.filter((item) => !commonKeys.includes(item.key)),
      })),
    };
  });
};
